//
$(document).ready(function(){
  // Define the Function targetBlank()
  targetBlank();
});
function targetBlank() {
  // remove subdomain of current site's url and setup regex
  var internal = location.host.replace("www.", "");
  internal = new RegExp(internal, "i");

  var a = $('a'); // then, grab every link on the page
  for (var i = 0; i < a.length; i++) {
    var host = a[i].host;
    var href = a[i].href;
    if( !internal.test(host) && !href.includes("ledrivetoutnu.com/pages/nos-magasins") ) { // make sure the href doesn't contain current site's host
      a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
    }
  }
};
